var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 29.7C8.9249 29.7 1.3999 25.325 1.3999 15.725C1.3999 6.125 8.9249 1.75 15.8999 1.75C19.7749 1.75 23.3499 3.025 25.9999 5.35C28.8749 7.9 30.3999 11.5 30.3999 15.725C30.3999 19.95 28.8749 23.525 25.9999 26.075C23.3499 28.4 19.7499 29.7 15.8999 29.7Z",
    fill: "url(#paint0_radial_846_164189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8725 7.41748C29.205 9.56748 29.9 12.1275 29.9 14.975C29.9 19.2 28.375 22.775 25.5 25.325C22.85 27.65 19.25 28.95 15.4 28.95C10.885 28.95 6.14998 27.1125 3.35498 23.215C6.04498 27.63 11.105 29.7 15.9 29.7C19.75 29.7 23.35 28.4 26 26.075C28.875 23.525 30.4 19.95 30.4 15.725C30.4 12.54 29.5325 9.70998 27.8725 7.41748Z",
    fill: "#EB8F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0998 20.825C15.2048 20.825 14.3173 20.675 13.4748 20.375C12.4373 20.0175 11.3098 20.57 10.9523 21.605C10.7498 22.19 10.8323 22.835 11.1748 23.35C12.2498 25 13.9498 25.9 16.0998 25.9C18.2498 25.9 19.9498 25 21.0248 23.35C21.6323 22.4375 21.3823 21.205 20.4698 20.5975C19.9548 20.255 19.3098 20.1725 18.7248 20.375C17.8823 20.675 16.9948 20.825 16.0998 20.825Z",
    fill: "#422B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.54981 22.3C10.9661 22.3 12.9248 20.4532 12.9248 18.175C12.9248 15.8968 10.9661 14.05 8.54981 14.05C6.13356 14.05 4.1748 15.8968 4.1748 18.175C4.1748 20.4532 6.13356 22.3 8.54981 22.3Z",
    fill: "url(#paint1_radial_846_164189)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.6499 22.3C26.0661 22.3 28.0249 20.4532 28.0249 18.175C28.0249 15.8968 26.0661 14.05 23.6499 14.05C21.2337 14.05 19.2749 15.8968 19.2749 18.175C19.2749 20.4532 21.2337 22.3 23.6499 22.3Z",
    fill: "url(#paint2_radial_846_164189)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8975 8.59252C24.845 8.01502 23.3375 9.69252 23.3375 9.69252C23.3375 9.69252 23.1625 7.79002 21.4075 7.19252C19.3025 6.47002 17.08 7.62002 16.9475 10.6025C16.7975 14 21.2925 18.46 21.2925 18.46C21.2925 18.46 26.8725 16.96 28.7 13.78C30.1875 11.1925 28.45 9.02752 26.8975 8.59252Z",
    fill: "#F44336"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8976 8.59249C26.6451 8.52499 26.3851 8.49499 26.1251 8.49999C26.8601 8.99249 27.4426 9.67999 27.8051 10.485C28.1576 11.3325 28.2501 12.4275 27.5801 13.735C26.1276 16.5775 21.6551 18.3375 21.3301 18.46C21.7376 18.345 26.9526 16.845 28.7101 13.7875C30.1876 11.1925 28.4501 9.02749 26.8976 8.59249Z",
    fill: "#C62828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.335 9.99999C23.32 9.73999 23.28 9.47999 23.22 9.22499C23.075 8.48999 22.62 7.85249 21.97 7.47499C21.525 7.21499 21.0325 7.04999 20.5225 6.98749C20.5225 6.98749 21.2725 7.21499 21.8075 8.25249C22.08 8.79749 22.2425 9.39249 22.2825 9.99999C22.28 10.2225 22.32 10.44 22.4 10.6475C22.49 10.855 22.71 10.9775 22.935 10.9425C23.2775 10.855 23.3525 10.4275 23.335 9.99999Z",
    fill: "#C62828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4749 8.8075C18.9424 8.2275 19.7098 7.675 20.4449 8.185C20.8348 8.4575 20.8398 9.23 20.3623 9.5775C19.5573 10.1675 19.5199 10.555 19.4299 10.88C19.3199 11.2675 19.2498 11.73 18.8973 11.925C18.5448 12.12 18.2348 11.925 18.0498 11.3675C17.7348 10.4975 17.8949 9.5275 18.4749 8.8075Z",
    fill: "#FF847A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1798 7.14252C8.15228 7.80002 7.82728 10.0325 7.82728 10.0325C7.82728 10.0325 6.62728 8.53252 4.82728 9.01752C2.67978 9.58252 1.46728 11.7725 2.99978 14.325C4.77478 17.25 10.9848 18.4625 10.9848 18.4625C10.9848 18.4625 14.7973 14.1225 14.5573 10.4625C14.3598 7.48252 11.7123 6.64502 10.1798 7.14252Z",
    fill: "#F44336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.18 7.14248C9.93254 7.22248 9.69504 7.33748 9.47754 7.48248C10.3625 7.48498 11.2275 7.73498 11.9775 8.20498C12.7425 8.70498 13.425 9.57498 13.595 11.0375C13.9625 14.21 11.2125 18.1525 11 18.44C11.2775 18.12 14.785 13.98 14.555 10.46C14.36 7.48248 11.7125 6.64498 10.18 7.14248Z",
    fill: "#C62828"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.295C7.845 10.0825 7.67 9.88748 7.475 9.71248C6.95 9.17748 6.2225 8.89248 5.475 8.93248C4.9625 8.96248 4.46 9.09498 4 9.32748C4 9.32748 4.75 9.09998 5.77 9.66998C6.3025 9.97748 6.765 10.39 7.135 10.88C7.255 11.0675 7.41 11.2275 7.5925 11.355C7.7825 11.4775 8.0325 11.455 8.2 11.3025C8.4225 11.0325 8.25 10.6375 8 10.295Z",
    fill: "#C62828"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29996 12C3.30996 11.79 3.34746 11.5825 3.40996 11.3825C3.51246 10.9625 3.80996 10.615 4.20746 10.4475C4.58996 10.3275 5.11996 10.4125 5.32496 10.795C5.50746 11.135 5.37496 11.545 5.27496 11.92C5.18496 12.35 5.13496 12.79 5.12496 13.23C5.12746 13.59 4.83996 13.8825 4.47996 13.8875C4.13996 13.8875 3.87496 13.5925 3.68496 13.31C3.41996 12.925 3.28496 12.4675 3.29996 12Z",
    fill: "#FF847A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_846_164189",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8999 15.725) scale(14.2399 14.2399)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_846_164189",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.54981 16.2776) scale(4.76797 4.28144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_846_164189",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7799 631.897) scale(4.865 4.865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0f758b55.svg";
export { ForwardRef as ReactComponent };